<template>
  <div>
    <CredentialCardHeader
      v-for="(credencial, index) in credenciales"
      :key="credencial.hash"
      class="border-2 border-teal-100"
      :class="index === 0 ? 'mt-4' : '-mt-6'"
      :credencial="credencial"
      @click="showCredential(credencial)"
    />
  </div>
</template>

<script>
import { mixins } from '@colescba/componentes-web'
import CredentialCardHeader from '@/components/CredentialCardHeader'

export default {
  mixins: [mixins.SendsToasts],

  components: { CredentialCardHeader },

  methods: {
    showCredential(credencial) {
      this.$router.push({ path: `/credential/${credencial.numero}` })
    },
  },

  computed: {
    credenciales() {
      return this.user.credenciales
    },

    user() {
      return this.$attrs.user
    },
  },
}
</script>
